import React from 'react';

const NumberWidget = ({ settings, value, onChange }) => {
  const step = settings?.step || 1;
  const min = settings?.min;
  const max = settings?.max;
  const defaultVal = settings?.default;

  React.useEffect(() => {
    if (!value && defaultVal != null) onChange(String(defaultVal));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const inputStyle = {
    padding: '8px 12px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    fontSize: '0.9rem',
    outline: 'none',
    width: '120px',
  };

  return (
    <input
      type="number"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      step={step}
      min={min}
      max={max}
      style={inputStyle}
    />
  );
};

export default NumberWidget;
